import React, { Component } from "react";
import config from "react-global-configuration";
import RequestApi from "../../Miscelania/RequestApi";

// Helpers de formulário
import InputMask from "react-input-mask";
import Select from "react-select";
import Toggle from "react-toggle";

import BaseSettings from "./BaseSettings";

class BasesEditTab extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: "",
        type: "",
        status: "closed",
      },
      redirect_url: false,
      loaded: 0,
      states: [],
      id: this.props.base_id,
      name: this.props.base_data.name,
      abbreviation: this.props.base_data.abbreviation,
      sapiens_abbreviation: this.props.base_data.sapiens_abbreviation,
      rubi_abbreviation: this.props.base_data.rubi_abbreviation,
      city: this.props.base_data.city,
      uf: this.props.base_data.uf,
      cep: this.props.base_data.cep,
      email_ptbr: this.props.base_data.email_ptbr,
      phone: this.props.base_data.phone,
      sigtrip_id: this.props.base_data.sigtrip_id,
      transportation: this.props.base_data.transportation,
      deslocation: this.props.base_data.deslocation,
      daily: this.props.base_data.daily,
      force_daily: this.props.base_data.force_daily,
      observations: this.props.base_data.observations,
      base_settings: [],
      sigtrip_bases: [],
      bases_rubi: [],
      base_dates: [],
    };

    //bind específico
    this.edit = this.edit.bind(this);
    this.getCep = this.getCep.bind(this);
    this.addMask = this.addMask.bind(this);
    this.addCode = this.addCode.bind(this);
    this.deleteCode = this.deleteCode.bind(this);
    this.addDate = this.addDate.bind(this);
    this.deleteDate = this.deleteDate.bind(this);
  }
  // Handlers
  handleChange(name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }
  handleSelectChange(name, event) {
    var change = {};
    if (event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }

  handleToggleChange(name, event) {
    var change = {};
    if (event.target.checked === true) {
      var value = 1;
    } else {
      var value = 0;
    }
    change[name] = value;
    this.setState(change);
  }

  handleChangeCep(name, event) {
    var change = {};
    var valido = /[0-9]{5}-[0-9]{3}$/.test(event.target.value);
    change[name] = event.target.value;
    this.setState(change);
    if (valido === true) {
      this.getCep(event.target.value);
    } else {
      this.setState({
        city: null,
        uf: null,
      });
    }
  }

  // LM
  componentWillReceiveProps(newProps) {
    if (
      (this.state.loaded === 0 &&
        typeof newProps.base_data.name !== "undefined" &&
        Array.isArray(newProps.states)) ||
      (this.state.loaded === 1 && newProps.updated === 1)
    ) {
      this.setState({
        id: newProps.base_id,
        name: newProps.base_data.name,
        abbreviation: newProps.base_data.abbreviation,
        sapiens_abbreviation: newProps.base_data.sapiens_abbreviation,
        rubi_abbreviation: newProps.base_data.rubi_abbreviation,
        city: newProps.base_data.city,
        uf: newProps.base_data.uf,
        cep: newProps.base_data.cep,
        email_ptbr: newProps.base_data.email_ptbr,
        phone: newProps.base_data.phone,
        sigtrip_id: newProps.base_data.sigtrip_id,
        transportation: newProps.base_data.transportation,
        deslocation: newProps.base_data.deslocation,
        daily: newProps.base_data.daily,
        force_daily: newProps.base_data.force_daily,
        observations: newProps.base_data.observations,
        states: newProps.states,
        roles: newProps.roles,
        sigtrip_bases: newProps.sigtrip_bases,
        base_settings: newProps.base_settings,
        loaded: 1,
      });
    }
    if (Array.isArray(newProps.bases_rubi) && this.state.loaded === 0) {
      this.setState({ bases_rubi: newProps.bases_rubi });
    }
    if (Array.isArray(newProps.base_dates) && this.state.loaded === 0) {
      this.setState({ base_dates: newProps.base_dates });
    }
  }

  edit(event) {
    event.preventDefault();
    var datasave = {
      id: this.state.id,
      name: this.state.name,
      abbreviation: this.state.abbreviation,
      sapiens_abbreviation: this.state.sapiens_abbreviation,
      rubi_abbreviation: this.state.rubi_abbreviation,
      city: this.state.city,
      uf: this.state.uf,
      cep: this.state.cep,
      email_ptbr: this.state.email_ptbr,
      phone: this.state.phone,
      sigtrip_id: this.state.sigtrip_id,
      transportation: this.state.transportation,
      deslocation: this.state.deslocation,
      daily: this.state.daily,
      force_daily: this.state.force_daily,
      observations: this.state.observations,
    };
    var header = this.refs.request_api.header("application/json");
    var self = this;
    self.props.handleAlert("", "", "open");
    Promise.resolve(header).then(function (value) {
      fetch(config.get("api") + "/base", {
        method: "PUT",
        mode: "cors",
        headers: value,
        body: JSON.stringify(datasave),
      })
        .then((response) => response.json())
        .catch((error) => {
          console.error(error);
        })
        .then((responseJson) => {
          self.refs.request_api.validate(responseJson, "alert");
          self.props.handleAlert(
            responseJson.message,
            responseJson.status,
            "open"
          );
        })
        .catch((error) => {
          console.error(error);
        });
    });
  }

  getCep(event) {
    var self = this;
    var header = this.refs.request_api.header("application/json");
    var url = config.get("api_correios") + "/" + event + "/json/";
    fetch(url, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    })
      .then((response) => response.json())
      .catch((error) => {
        console.error(error);
      })
      .then((responseJson) => {
        if (typeof responseJson.erro === "undefined") {
          self.setState({
            city: responseJson.localidade,
            uf: responseJson.uf,
          });
        } else {
          self.props.handleAlert("CEP não encontrado", "error", "open");
        }
      });
  }

  addMask(event) {
    event.preventDefault();
    this.props.handleAlert("", "", "open");
    var datasave = {
      base_id: this.state.id,
      mask_name: this.state.mask_name,
    };
    var header = this.refs.request_api.header("application/json");
    var self = this;
    Promise.resolve(header).then(function (value) {
      fetch(config.get("api") + "/base/mascara", {
        method: "POST",
        mode: "cors",
        headers: value,
        body: JSON.stringify(datasave),
      })
        .then((response) => response.json())
        .catch((error) => {
          console.error(error);
        })
        .then((responseJson) => {
          self.refs.request_api.validate(responseJson, "alert");
          self.props.updateData(responseJson);
        })
        .catch((error) => {
          console.error(error);
        });
    });
  }

  // Fetch salvando a edição
  addCode(event) {
    event.preventDefault();
    this.props.handleAlert("", "", "open");
    var datasave = {
      base_id: this.state.id,
      rubi_code: this.state.rubi_code,
    };
    var header = this.refs.request_api.header("application/json");
    var self = this;
    Promise.resolve(header).then(function (value) {
      fetch(config.get("api") + "/rubi/base", {
        method: "POST",
        mode: "cors",
        headers: value,
        body: JSON.stringify(datasave),
      })
        .then((response) => response.json())
        .catch((error) => {
          console.error(error);
        })
        .then((responseJson) => {
          self.refs.request_api.validate(responseJson, "alert");
          self.setState({ loaded: 1 });
          self.setState({ bases_rubi: responseJson.data });
          self.props.handleAlert(
            responseJson.message,
            responseJson.status,
            "open"
          );
        })
        .catch((error) => {
          console.error(error);
        });
    });
  }

  // Fetch salvando a edição
  deleteCode(id) {
    if (
      window.confirm(
        "Tem certeza que deseja deletar este código de base do Rubi?"
      )
    ) {
      this.props.handleAlert("", "", "open");
      var header = this.refs.request_api.header("application/json");
      var self = this;
      Promise.resolve(header).then(function (value) {
        fetch(config.get("api") + "/rubi/base/" + id, {
          method: "DELETE",
          mode: "cors",
          headers: value,
        })
          .then((response) => response.json())
          .catch((error) => {
            console.error(error);
          })
          .then((responseJson) => {
            self.refs.request_api.validate(responseJson, "alert");
            self.setState({ loaded: 1 });
            self.setState({ bases_rubi: responseJson.data });
            self.props.handleAlert(
              responseJson.message,
              responseJson.status,
              "open"
            );
          })
          .catch((error) => {
            console.error(error);
          });
      });
    }
  }

  // Fetch salvando a edição
  addDate(event) {
    event.preventDefault();
    this.props.handleAlert("", "", "open");
    var datasave = {
      base_id: this.state.id,
      date: this.state.date,
    };
    var header = this.refs.request_api.header("application/json");
    var self = this;
    Promise.resolve(header).then(function (value) {
      fetch(config.get("api") + "/data/base", {
        method: "POST",
        mode: "cors",
        headers: value,
        body: JSON.stringify(datasave),
      })
        .then((response) => response.json())
        .catch((error) => {
          console.error(error);
        })
        .then((responseJson) => {
          self.refs.request_api.validate(responseJson, "alert");
          self.setState({ loaded: 1 });
          self.setState({ base_dates: responseJson.data });
          self.props.handleAlert(
            responseJson.message,
            responseJson.status,
            "open"
          );
        })
        .catch((error) => {
          console.error(error);
        });
    });
  }

  // Fetch salvando a edição
  deleteDate(id) {
    if (window.confirm("Tem certeza que deseja deletar esta data?")) {
      this.props.handleAlert("", "", "open");
      var header = this.refs.request_api.header("application/json");
      var self = this;
      Promise.resolve(header).then(function (value) {
        fetch(config.get("api") + "/data/base/" + id, {
          method: "DELETE",
          mode: "cors",
          headers: value,
        })
          .then((response) => response.json())
          .catch((error) => {
            console.error(error);
          })
          .then((responseJson) => {
            self.refs.request_api.validate(responseJson, "alert");
            self.setState({ loaded: 1 });
            self.setState({ base_dates: responseJson.data });
            self.props.handleAlert(
              responseJson.message,
              responseJson.status,
              "open"
            );
          })
          .catch((error) => {
            console.error(error);
          });
      });
    }
  }

  render() {
    var self = this;
    return (
      <div>
        <RequestApi ref={"request_api"} />
        <div>
          <form onSubmit={this.edit}>
            <div className="row">
              <div className="col-md-6 form-group">
                <label>Nome:</label>
                <input
                  type="text"
                  className="form-control"
                  name="name"
                  value={this.state.name}
                  onChange={this.handleChange.bind(this, "name")}
                />
              </div>
              <div className="col-md-6 form-group">
                <label>Abreviação:</label>
                <input
                  type="text"
                  className="form-control"
                  name="abbreviation"
                  value={this.state.abbreviation}
                  onChange={this.handleChange.bind(this, "abbreviation")}
                />
              </div>
            </div>
            <div className="row">
              <div className="col-md-6 form-group">
                <label>Abreviação - RUBI:</label>
                <input
                  type="text"
                  className="form-control"
                  name="rubi_abbreviation"
                  value={this.state.rubi_abbreviation}
                  onChange={this.handleChange.bind(this, "rubi_abbreviation")}
                />
              </div>
              <div className="col-md-6 form-group">
                <label>Abreviação - SAPIENS:</label>
                <input
                  type="text"
                  className="form-control"
                  name="sapiens_abbreviation"
                  value={this.state.sapiens_abbreviation}
                  onChange={this.handleChange.bind(
                    this,
                    "sapiens_abbreviation"
                  )}
                />
              </div>
            </div>
            <div className="row">
              <div className="col-md-6 form-group">
                <label>Cidade:</label>
                <input
                  type="text"
                  className="form-control"
                  name="city"
                  value={this.state.city}
                  onChange={this.handleChange.bind(this, "city")}
                />
              </div>
              <div className="col-md-6 form-group">
                <label>Estado:</label>
                <Select
                  className="form-field-name"
                  name="uf"
                  value={this.state.uf}
                  searchable={true}
                  placeholder={"Selecionar estado"}
                  onChange={this.handleSelectChange.bind(this, "uf")}
                  options={this.state.states}
                />
              </div>
            </div>
            <div className="row">
              <div className="col-md-6 form-group">
                <label>Telefone:</label>
                <InputMask
                  value={this.state.phone}
                  maskChar={null}
                  name="phone"
                  mask="(99) 9999-99999"
                  className="form-control"
                  onChange={this.handleChange.bind(this, "phone")}
                  placeholder="Telefone da base"
                />
              </div>
              <div className="col-md-6 form-group">
                <label>Equivalência no SIGTRIP:</label>
                <Select
                  className="form-field-name"
                  name="sigtrip_id"
                  value={this.state.sigtrip_id}
                  searchable={true}
                  placeholder={""}
                  onChange={this.handleSelectChange.bind(this, "sigtrip_id")}
                  options={this.state.sigtrip_bases}
                />
              </div>
            </div>
            <div className="row">
              <div className="col-md-6">
                <div className="form-group">
                  <label>Diária obrigatória:</label>
                  <br />
                  <Toggle
                    defaultChecked={this.state.force_daily}
                    checked={this.state.force_daily}
                    aria-label="No label tag"
                    name="force_daily"
                    onChange={this.handleToggleChange.bind(this, "force_daily")}
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <label>Diárias adicionais:</label>
                  <input
                    value={this.state.daily}
                    type="text"
                    name="daily"
                    className="form-control"
                    onChange={this.handleChange.bind(this, "daily")}
                    placeholder=""
                  />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6">
                <div className="form-group">
                  <label>Verba indenizatória de Transporte:</label>
                  <br />
                  <Toggle
                    defaultChecked={this.state.transportation}
                    checked={this.state.transportation}
                    aria-label="No label tag"
                    name="transportation"
                    onChange={this.handleToggleChange.bind(
                      this,
                      "transportation"
                    )}
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <label>Verba indenizatória de Deslocamento:</label>
                  <br />
                  <Toggle
                    defaultChecked={this.state.deslocation}
                    checked={this.state.deslocation}
                    aria-label="No label tag"
                    name="deslocation"
                    onChange={this.handleToggleChange.bind(this, "deslocation")}
                  />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6 form-group">
                <label>CEP:</label>
                <InputMask
                  maskChar={null}
                  name="cep"
                  mask="99999-999"
                  className="form-control"
                  onChange={this.handleChangeCep.bind(this, "cep")}
                  placeholder="CEP"
                />
              </div>
              <div className="col-md-6 form-group">
                <label>E-mail PTBR:</label>
                <br />
                <Toggle
                  defaultChecked={this.state.email_ptbr}
                  checked={this.state.email_ptbr}
                  aria-label="No label tag"
                  name="email_ptbr"
                  onChange={this.handleToggleChange.bind(this, "email_ptbr")}
                />
              </div>
            </div>
            <div className="row">
              <div className="col-md-6">
                <div className="form-group">
                  <label>Observações:</label>
                  <textarea
                    style={{ height: 200 }}
                    type="text"
                    name="observations"
                    className="form-control"
                    value={this.state.observations}
                    onChange={this.handleChange.bind(this, "observations")}
                  />
                </div>
              </div>
            </div>
            <hr />
            <button
              type={"submit"}
              className="btn btn-primary btn-lg btn-block"
            >
              <i className="fa fa-fw fa-save"></i> Editar base
            </button>
          </form>
          <hr />
          <h4>Bases - Rubi</h4>
          <hr />
          <form onSubmit={this.addCode}>
            <div className="row">
              <div className="col-md-6">
                <div className="form-group">
                  <label>Código Rubi:</label>
                  <InputMask
                    type="text"
                    name="rubi_code"
                    className="form-control"
                    placeholder="Código Rubi"
                    value={this.state.rubi_code}
                    onChange={this.handleChange.bind(this, "rubi_code")}
                  />
                </div>
              </div>
              <div className="col-md-6">
                <button
                  type="submit"
                  className="btn btn-primary btn-inline btn-block"
                >
                  <i className="fa fa-fw fa-plus"></i> Adicionar
                </button>
              </div>
            </div>
          </form>
          <hr />
          <table className="table">
            <thead>
              <tr>
                <th>#</th>
                <th>Código</th>
                <th className="col-md-1">Ações</th>
              </tr>
            </thead>
            <tbody id="rubi_codes">
              {Object.keys(self.state.bases_rubi).map(function (k) {
                return (
                  <tr>
                    <td>{self.state.bases_rubi[k].id}</td>
                    <td>{self.state.bases_rubi[k].rubi_code}</td>
                    <td>
                      <button
                        className="btn btn-sm btn-danger"
                        value={self.state.bases_rubi[k].id}
                        onClick={() =>
                          self.deleteCode(self.state.bases_rubi[k].id)
                        }
                      >
                        <i className="fa fa-fw fa-trash"></i>
                      </button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
          <hr />
          <h4>Datas de Troca</h4>
          <p className="bg-info" style={{ padding: 10 }}>
            <i className="fa fa-fw fa-warning"></i> Estas datas não pagam
            deslocamento.
          </p>
          <hr />
          <form onSubmit={this.addDate}>
            <div className="row">
              <div className="col-md-6">
                <div className="form-group">
                  <label>Data:</label>
                  <InputMask
                    value={this.state.date}
                    maskChar={null}
                    name="date"
                    mask="99/99/9999"
                    className="form-control"
                    onChange={this.handleChange.bind(this, "date")}
                    placeholder="dd/mm/yyyy"
                  />
                </div>
              </div>
              <div className="col-md-6">
                <button
                  type="submit"
                  className="btn btn-primary btn-inline btn-block"
                >
                  <i className="fa fa-fw fa-save"></i> Adicionar
                </button>
              </div>
            </div>
          </form>
          <hr />
          <div className="table-responsive">
            <table className="table table-bordered table-hover table-striped">
              <thead>
                <tr>
                  <th>Data</th>
                  <th></th>
                </tr>
              </thead>
              <tbody id="dates">
                {Object.keys(self.state.base_dates).map(function (k) {
                  var bd = self.state.base_dates[k];
                  return (
                    <tr>
                      <td>{bd.date_str}</td>
                      <td className="text-center">
                        <button
                          onClick={() => self.deleteDate(bd.id)}
                          className="btn btn-danger btn-sm"
                        >
                          <i className="fa fa-trash"></i>
                        </button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          <hr />
          <h4>Adicionar máscara de funções</h4>
          <hr />
          <form onSubmit={this.addMask}>
            <div className="row">
              <div className="col-md-6 form-group">
                <label>Nome:</label>
                <input
                  type="text"
                  className="form-control"
                  name="mask_name"
                  value={this.state.mask_name}
                  onChange={this.handleChange.bind(this, "mask_name")}
                />
              </div>
              <div className="col-md-6 form-group">
                <button
                  type={"submit"}
                  className="btn btn-primary btn-block btn-inline"
                >
                  <i className="fa fa-fw fa-save"></i> Adicionar máscara
                </button>
              </div>
            </div>
          </form>
          <hr />
          {Object.keys(self.state.base_settings).map(function (k) {
            return (
              <BaseSettings
                handleAlert={self.props.handleAlert}
                updateData={self.props.updateData}
                base_setting={self.state.base_settings[k]}
                base_id={self.state.id}
                base_settings_id={self.state.base_settings[k].id}
                roles={self.state.roles}
              />
            );
          })}
        </div>
      </div>
    );
  }
}

export default BasesEditTab;



// WEBPACK FOOTER //
// ./src/Components/Bases/Elements/BasesEditTab.js